import { Text } from '@shared/components';
import { useCallback, useRef } from 'react';

type EditableTextProps = {
  value: string;
  isEditable?: boolean;
  onEdit?: (newValue: string) => void;
};

export function EditableText({ value, isEditable, onEdit }: EditableTextProps) {
  const preRef = useRef<HTMLPreElement>(null);
  const dirtyRef = useRef(false);

  const handleInput = useCallback(() => {
    dirtyRef.current = true;
  }, []);

  const handleBlur = useCallback(() => {
    if (!preRef.current || !onEdit || !dirtyRef.current) return;
    dirtyRef.current = false;
    const newValue = preRef.current.textContent ?? '';
    onEdit(newValue);
  }, [onEdit]);

  if (isEditable && onEdit) {
    return (
      <pre
        ref={preRef}
        className="text-body-xs whitespace-pre-wrap"
        contentEditable
        suppressContentEditableWarning
        onInput={handleInput}
        onBlur={handleBlur}
      >
        {value}
      </pre>
    );
  }

  return (
    <pre className="whitespace-pre-wrap">
      <Text type="body-xs">{value}</Text>
    </pre>
  );
}
